import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { ButtonLink } from '..';
import { ROUTES } from '../../../constants';

type Props = {
  history: Object,
};

class OrderHistoryLinkComponent extends Component<Props> {
  handleClick = () => {
    const { history } = this.props;
    history.push(ROUTES.PATH.ORDER_HISTORY);
  };

  render() {
    return (
      <ButtonLink
        dataId="backToOnlineHistory"
        content="Back to Online History"
        onClick={this.handleClick}
      />
    );
  }
}

export default withRouter(OrderHistoryLinkComponent);
